import { render, staticRenderFns } from "./payment-callback-list.vue?vue&type=template&id=8aefab06&scoped=true"
import script from "./payment-callback-list.vue?vue&type=script&lang=js"
export * from "./payment-callback-list.vue?vue&type=script&lang=js"
import style0 from "./payment-callback-list.vue?vue&type=style&index=0&id=8aefab06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aefab06",
  null
  
)

export default component.exports